import { NAV_LINKS, SUBURBS } from "@/lib/content";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-cacao text-pearl/80 pt-8 pb-12 md:pb-16 border-t border-pearl/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <p className="font-serif italic text-pearl/85 text-[1.4rem] md:text-[1.7rem] py-12 md:py-20 border-b border-pearl/10 max-w-[40rem]">
                    Arc &amp; Light — design that feels like home.
                </p>

                <div className="pt-10 md:pt-14 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-start">
                    <div className="md:col-span-5">
                        <a
                            href="#top"
                            aria-label="Arc & Light — home"
                            className="inline-block leading-none"
                        >
                            <img
                                src="/logos/arc-light-white.png"
                                alt="Arc & Light"
                                width="220"
                                height="14"
                                className="h-[12px] md:h-[13px] w-auto max-w-none opacity-95 select-none block"
                                draggable="false"
                            />
                        </a>
                        <p className="mt-6 text-pearl/60 text-[0.72rem] tracking-[0.28em] uppercase">
                            Interior Design Consultancy · Brisbane
                        </p>
                        <p className="mt-3 text-pearl/60 text-[0.8rem] leading-[1.7] max-w-[24rem]">
                            Servicing — {SUBURBS}
                        </p>
                    </div>

                    <nav className="md:col-span-4 flex flex-wrap gap-x-8 gap-y-3">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                className="text-pearl/80 text-[0.78rem] tracking-[0.22em] uppercase font-medium hover:text-clay transition-colors duration-500"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="md:col-span-3 md:text-right space-y-3 text-pearl/70 text-[0.8rem]">
                        <p className="font-serif italic text-[0.95rem] text-pearl/90">
                            merilyn@merilyn.com.au
                        </p>
                        <div className="pt-1 md:flex md:flex-col md:items-end">
                            <p className="text-pearl/55 text-[0.66rem] tracking-[0.3em] uppercase">
                                Instagram
                            </p>
                            <a
                                href="https://www.instagram.com/arcandlightinteriors/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-1 inline-block font-serif italic text-pearl/90 hover:text-clay text-[1rem] transition-colors duration-500"
                            >
                                @arcandlightinteriors
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-pearl/10 flex flex-col md:flex-row justify-between gap-3 text-pearl/55 text-[0.7rem] tracking-[0.2em] uppercase">
                    <span>© {new Date().getFullYear()} Arc &amp; Light</span>
                    <span>Privacy · Considered, never tracked</span>
                </div>
            </div>
        </footer>
    );
}
